document.addEventListener('DOMContentLoaded', function () {
  // Smooth scroll for anchor links that point to IDs on the page
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      // Only handle links that point to an ID on the current page
      const targetId = this.getAttribute('href');
      
      // Skip if it's just "#" or empty
      if (targetId === '#' || targetId === '') {
        return;
      }
      
      const targetElement = document.querySelector(targetId);
      
      // Only proceed if the target element exists on the page
      if (targetElement) {
        e.preventDefault();
        smoothScrollToElement(targetElement);
        
        // Close mobile menu if it's open
        closeMobileMenuIfOpen();
        
        // Update the URL hash without scrolling (for better history/bookmarking)
        history.pushState(null, '', targetId);
      }
    });
  });
  
  // Also handle links that include the current page path plus a hash
  const currentPath = window.location.pathname;
  document.querySelectorAll(`a[href^="${currentPath}#"]`).forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      const hashPart = href.substring(href.indexOf('#'));
      const targetElement = document.querySelector(hashPart);
      
      if (targetElement) {
        e.preventDefault();
        smoothScrollToElement(targetElement);
        
        // Close mobile menu if it's open
        closeMobileMenuIfOpen();
        
        history.pushState(null, '', hashPart);
      }
    });
  });
  
  // Handle page load with hash in URL
  if (window.location.hash) {
    // Small delay to ensure page is fully loaded
    setTimeout(function() {
      const targetElement = document.querySelector(window.location.hash);
      if (targetElement) {
        smoothScrollToElement(targetElement);
      }
    }, 300);
  }
  
  // Helper function to close mobile menu if it's open
  function closeMobileMenuIfOpen() {
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer) {
      const detailsElement = headerDrawer.querySelector('details[open]');
      if (detailsElement) {
        const summaryElement = detailsElement.querySelector('summary');
        
        // Simulate clicking the summary element to properly close the menu
        if (summaryElement) {
          summaryElement.click();
        }
      }
    }
  }
  
  // Helper function for smooth scrolling to an element
  function smoothScrollToElement(element) {
    // Get the header height (if you have a fixed header)
    const headerOffset = document.querySelector('header.header')?.offsetHeight || 0;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 20; // 20px extra padding
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
});